'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { useTranslations } from 'next-intl';
import { useScript } from 'usehooks-ts';
import { RECAPTCHA_SITE_KEY } from '@/utility/constants';
declare global {
  const grecaptcha: {
    enterprise: {
      ready: (cb: () => void) => void;
      execute: (siteKey: string, options: {
        action: string;
      }) => Promise<string>;
    };
  };
}
interface Props {
  action: string;
}
export function RecaptchaWrapper(t0) {
  const $ = _c(10);
  const {
    action
  } = t0;
  const t = useTranslations();
  const tokenInputRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      removeOnUnmount: true,
      id: "recaptcha-script"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const recaptchaScriptStatus = useScript(`https://www.google.com/recaptcha/enterprise.js?render=${RECAPTCHA_SITE_KEY}`, t1);
  let t2;
  let t3;
  if ($[1] !== action || $[2] !== recaptchaScriptStatus) {
    t2 = () => {
      if (recaptchaScriptStatus !== "ready") {
        return;
      }
      if (typeof grecaptcha !== "undefined") {
        grecaptcha.enterprise.ready(async () => {
          ;
          try {
            const token = await grecaptcha.enterprise.execute(RECAPTCHA_SITE_KEY, {
              action
            });
            const tokenInput = tokenInputRef.current;
            if (tokenInput) {
              tokenInput.value = token;
            }
          } catch (t4) {
            const e = t4;
            console.error("Recaptcha error", e);
          }
        });
      }
    };
    t3 = [action, recaptchaScriptStatus];
    $[1] = action;
    $[2] = recaptchaScriptStatus;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <input type="hidden" name="recaptchaToken" id="recaptcha-token" ref={tokenInputRef} />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t.rich("recaptcha.disclaimer", {
      privacyLink: _temp,
      termsLink: _temp2
    });
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <>{t4}<p className="text-xs text-black">{t5}</p></>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}
function _temp2(chunks_0) {
  return <a target="_blank" className="font-semibold underline" href="https://policies.google.com/terms">{chunks_0}</a>;
}
function _temp(chunks) {
  return <a target="_blank" className="font-semibold underline" href="https://policies.google.com/privacy">{chunks}</a>;
}